import React from "react";

import * as S from "./styles";
import { ArrowProps } from "./types";

export const Arrow = ({
  variant = "next",
  mode = "light",
  overlay = false,
  onClick,
}: ArrowProps) => {
  return (
    <S.Container
      overlay={overlay}
      onClick={onClick}
      className={`arrow-${variant}`}
    >
      <S.ArrowWrapper variant={variant} mode={mode}>
        <svg
          role='img'
          width='16.77'
          height='26.67'
          viewBox='0 0 17 28'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0.313171 1.03898C-0.0569567 1.48316 0.0170688 2.22342 0.461229 2.59358L14.008 13.9936L0.461228 25.3937C-0.056957 25.7638 -0.056957 26.43 0.313171 26.9482C0.683305 27.3924 1.42357 27.4664 1.86771 27.0963L16.4509 14.8819C16.673 14.6599 16.8211 14.3637 16.8211 13.9936C16.8211 13.6975 16.673 13.3274 16.4509 13.1053L1.86771 0.964964C1.42357 0.520851 0.683305 0.59487 0.313171 1.03898Z' />
        </svg>
      </S.ArrowWrapper>
    </S.Container>
  );
};
